const config = {
    apiProtocol: 'http',
    apiUrl: ''
};
export default config;
